import React, { useState } from 'react';

const AddAccountModal = ({ isOpen, onClose, onAddAccount, scope }) => {
    const [accountName, setAccountName] = useState('');
    const [initialBalance, setInitialBalance] = useState('0');
    const [accountType, setAccountType] = useState('debit');
    const [creditLimit, setCreditLimit] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddAccount({ accountName, initialBalance, scope, accountType, creditLimit });
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Create New Account</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Account Name</label>
                        <input type="text" value={accountName} onChange={(e) => setAccountName(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Account Type</label>
                        <select value={accountType} onChange={(e) => setAccountType(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                            <option value="debit">Debit</option>
                            <option value="credit">Credit</option>
                            <option value="savings">Savings</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">{accountType === 'credit' ? 'Current Balance (Amount Owed)' : 'Initial Balance'}</label>
                        <input type="number" step="0.01" value={initialBalance} onChange={(e) => setInitialBalance(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    {accountType === 'credit' && (
                        <div>
                            <label className="block text-sm font-medium">Credit Limit</label>
                            <input type="number" step="0.01" value={creditLimit} onChange={(e) => setCreditLimit(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" placeholder="5000" required />
                        </div>
                    )}
                    <div className="flex justify-end space-x-3 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md">Create Account</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddAccountModal;